export default __webpack_public_path__ + "static/1ladderbench-aaedb0cec6ac169d1785161d620575be.png";